import React from "react";
import { getInitials } from "../../../../../../shared/utils/utils";
import classes from "./SearchResultsDropdown.module.css";

const SearchResultsDropdown = ({ results, selectedUser, onSelect }) => {
    return (
        <div className={classes.Dropdown}>
            {results?.length > 0
                ? results.map((participant) => {
                    const isSelected = selectedUser?.id === participant.id;
                    return (
                        <button
                            key={participant.id}
                            className={`${classes.ResultRow} ${isSelected ? classes.ResultRowSelected : ""}`}
                            onClick={() => onSelect(participant)}
                            type="button"
                        >
                            <div className={classes.Radio}>
                                {isSelected && <div className={classes.RadioInner} />}
                            </div>
                            <div className={classes.Avatar}>
                                <span className={classes.Initials}>
                                    {getInitials(participant.firstName, participant.lastName)}
                                </span>
                            </div>
                            <span className={classes.Name}>
                                {`${participant.firstName} ${participant.lastName}`}
                            </span>

                        </button>
                    );
                })
                : <div className={classes.Empty} />
            }
        </div>
    );
};

export default SearchResultsDropdown;
